import React from 'react';
import { company, offer, shots } from '../../data/offer';
export function Letterhead() {
  return <header className="relative isolate overflow-hidden border-b border-line" data-id="element-27" data-mp="1ser4rultulby">
      <img src={shots.site} alt="" aria-hidden="true" className="absolute inset-0 -z-10 h-full w-full object-cover object-top opacity-20" data-id="element-28" data-mp="1eezvg7699t4a" />
      <div aria-hidden="true" className="absolute inset-0 -z-10 bg-ink/85" data-id="element-29" data-mp="1jfnkwoeu61we" />

      <div className="mx-auto max-w-5xl px-8 py-8 md:px-12" data-id="element-30" data-mp="14nd9bfsdq9mr">
        <div className="flex flex-wrap items-start justify-between gap-6 border-b border-line pb-6" data-id="element-31" data-mp="19fwogh6ptcto">
          <span className="text-sm font-semibold tracking-tight text-white" data-id="element-32" data-mp="vp1dmzcnolng">
            {company.name}
          </span>
          <div className="text-right text-xs leading-relaxed text-white/45" data-id="element-33" data-mp="zqmyb6vfm487">
            <p data-id="element-34" data-mp="lpsmsfd37n5b">{company.email}</p>
            <p data-id="element-35" data-mp="lqu9xi7do03e">{company.phone}</p>
            <p data-id="element-36" data-mp="qp5htne440iz">{company.address}</p>
          </div>
        </div>

        <div className="pb-14 pt-12 md:pb-16" data-id="element-37" data-mp="qodmmdofg4t8">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-accent" data-id="element-38" data-mp="b5etsqf43n8a">
            Offerte · {offer.date}
          </p>
          <h1 className="mt-5 max-w-3xl text-4xl font-semibold leading-[1.04] tracking-tight text-white md:text-6xl" data-id="element-39" data-mp="661yrie379um">
            {offer.subject}
          </h1>
          <p className="mt-5 text-base text-white/55" data-id="element-40" data-mp="f702s0oizhd7">Voor {offer.client}</p>

          <dl className="mt-10 grid max-w-2xl gap-px overflow-hidden rounded-xl border border-line bg-white/10 sm:grid-cols-3" data-id="element-41" data-mp="3nnbc126b8oxf">
            <div className="bg-ink px-5 py-4" data-id="element-42" data-mp="3jmj206pm6g03">
              <dt className="text-[11px] uppercase tracking-[0.16em] text-white/40" data-id="element-43" data-mp="3jnkmt2wfmgv0">Compleet pakket</dt>
              <dd className="mt-1.5 whitespace-nowrap text-xl font-semibold tracking-tight text-white" data-id="element-44" data-mp="19tnwh6xa2t9">
                {offer.price}
              </dd>
            </div>
            <div className="bg-ink px-5 py-4" data-id="element-45" data-mp="34vity2ss4o4h">
              <dt className="text-[11px] uppercase tracking-[0.16em] text-white/40" data-id="element-46" data-mp="2zxqqcbirvdkg">Doorlooptijd</dt>
              <dd className="mt-1.5 whitespace-nowrap text-xl font-semibold tracking-tight text-white" data-id="element-47" data-mp="13um0v1f837d2">
                {offer.duration}
              </dd>
            </div>
            <div className="bg-ink px-5 py-4" data-id="element-48" data-mp="18rm83fnt6g5r">
              <dt className="text-[11px] uppercase tracking-[0.16em] text-white/40" data-id="element-49" data-mp="1djvx8th3nc6z">Geldig t/m</dt>
              <dd className="mt-1.5 text-xl font-semibold tracking-tight text-white" data-id="element-50" data-mp="1ik0ewmtqucys">
                {offer.validUntil}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </header>;
}